import React, { Component } from "react";
import { connect } from "react-redux";

import { UiActions } from "state/actions/UiActions";

export default class ToggleMenuMobile extends Component {
  constructor (props) {
    super(props);

    this.toggle = this.toggle.bind(this);
  }

  toggle () {
    if (this.props.ui.menu.visible) {
      this.props.menuHide();
    } else {
      this.props.menuShow();
    }

    setTimeout(() => {
      //this.props.menuHide();
    }, 2000);
  }

  render () {
    return (
      <button onClick={this.toggle}>
        Toggle
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  ui: state.ui,
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  menuHide: () => {
    dispatch(UiActions.menuHide());
  },
  menuShow: () => {
    dispatch(UiActions.menuShow());
  }
});

ToggleMenuMobile = connect(
  mapStateToProps,
  mapDispatchToProps
)(ToggleMenuMobile);
